import { render, staticRenderFns } from "./journey-detail.vue?vue&type=template&id=1a8e980a&"
import script from "./journey-detail.vue.js?vue&type=script&lang=js&"
export * from "./journey-detail.vue.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports